import React, { forwardRef } from 'react'
import styled from 'styled-components'

import IconButton, {
    Props as IconButtonProps,
} from 'js/components/IconButton/IconButton'

const Wrapper = styled(IconButton)<IconButtonProps>`
    background-color: transparent;

    &[disabled] {
        color: ${(p) => p.theme.color.grey[30]};
    }

    &:focus,
    &:focus-visible {
        outline: ${(p) => p.theme.focusStyling};
    } // Make sure focus ring is visible, in some cases the first tool button doesn't show a focus ring when the toolbar is focused with the keyboard

    .IconButtonContent {
        flex-direction: row; // Fixes DropdownButton arrow
    }
`

type ToolButtonProps = Omit<IconButtonProps, 'children'> & {
    children: React.ReactElement | React.ReactElement[]
}

const ToolButton = forwardRef<HTMLButtonElement, ToolButtonProps>(
    ({ children, ...rest }, ref) => (
        <Wrapper
            ref={ref}
            size="large"
            variant="tertiary"
            radiusStyle="rounded"
            hoverSize="normal"
            tabIndex={-1}
            {...rest}
        >
            {children}
        </Wrapper>
    ),
)

ToolButton.displayName = 'ToolButton'

export default ToolButton
